export default __webpack_public_path__ + "static/media/logo.a0467aa3.png";